// Single source of truth for error-log sources / severities / statuses / date
// presets. Both ErrorLogs.js (filters + drawer) and ErrorTable.js (badges) import
// from here so a new source/severity never has to be added in two places.

export const SOURCE_OPTS = [
  { v: "all", l: "All sources" },
  { v: "asin_scrape", l: "ASIN scrape" },
  { v: "category_scrape", l: "Category scrape" },
  { v: "api_submission", l: "API submission" },
  { v: "system", l: "System" },
];

export const SEV_OPTS = [
  { v: "all", l: "All severities" },
  { v: "error", l: "Error" },
  { v: "warning", l: "Warning" },
  { v: "info", l: "Info" },
];

export const STATUS_OPTS = [
  { v: "all", l: "All statuses" },
  { v: "new", l: "New" },
  { v: "read", l: "Read" },
  { v: "resolved", l: "Resolved" },
];

export const DATE_OPTS = [
  { v: "all", l: "All time" },
  { v: "1", l: "Last 24 hours" },
  { v: "7", l: "Last 7 days" },
  { v: "30", l: "Last 30 days" },
  { v: "90", l: "Last 90 days" },
];

const labelMap = (opts) =>
  Object.fromEntries(opts.filter((o) => o.v !== "all").map((o) => [o.v, o.l]));

export const SOURCE_LABEL = labelMap(SOURCE_OPTS);
export const SEVERITY_LABEL = labelMap(SEV_OPTS);
export const STATUS_LABEL = labelMap(STATUS_OPTS);

// Badge classes (mca-badge--<class>).
export const SEVERITY_CLASS = { error: "soft-danger", warning: "soft-warning", info: "soft-info" };
export const STATUS_CLASS = { new: "soft-info", read: "soft-muted", resolved: "soft-success" };

// Map a date-preset value (DATE_OPTS) to an ISO date_from, or null for "all".
export const dateFromForRange = (v) => {
  const days = parseInt(v, 10);
  if (!days) return null;
  return new Date(Date.now() - days * 86400000).toISOString();
};
